import { loadSession } from "./storage.js";

/**
 * Fetch wrapper that adds the JWT Authorization header automatically and
 * parses API responses into a consistent shape.
 *
 * Success → returns parsed JSON body.
 * Failure → throws an Error with .status, .code, .details from { error: {...} }.
 *
 * Note: this wrapper does NOT auto-logout on 401. Callers decide — for
 * dashboard fetches we'll want to log out, but for login submissions we
 * need the caller to surface the message to the user.
 */
export async function apiFetch(path, options = {}) {
  const session = loadSession();
  const token = session?.token;

  const res = await fetch(path, {
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      ...options.headers,
    },
  });

  const body = await res.json().catch(() => ({}));

  if (!res.ok) {
    const err = new Error(body?.error?.message || `Request failed (HTTP ${res.status})`);
    err.status = res.status;
    err.code = body?.error?.code;
    err.details = body?.error?.details;
    throw err;
  }

  return body;
}
